/*
 * Obsluha stisku tlacitek a swipe na obrazovce
 */

// Inicializace vsech tlacitek 
import {madnes_set_input_down, madnes_set_input_up} from "../framework/src/engine/madnes/madnes";
import {ninestars_mystery_wheel_dn, ninestars_mystery_wheel_up} from "./ninestars_anims";

export function ninestars_init_btns_phaser()
{
    //madnes_set_input_down("wheel", ninestars_mystery_wheel_dn);
    //madnes_set_input_up("wheel", ninestars_mystery_wheel_up);

    madnes_set_input_down("bonus_background", ninestars_mystery_wheel_dn);
    madnes_set_input_up("bonus_background", ninestars_mystery_wheel_up);
}
